import React from 'react';

import GuidesPage from '../../js/pages/GuidesPage';
import {getGuidesListData} from '../../../server/services/guide';

export default function Page({
  guides, roleOptions, roleCategories, companyOptions,
}) {
  return (
    <GuidesPage
      guides={guides}
      roleOptions={roleOptions}
      roleCategories={roleCategories}
      companyOptions={companyOptions}
    />
  );
}

export async function getStaticProps() {
  const {
    guides, roleOptions, roleCategories, companyOptions,
  } = await getGuidesListData();

  return {
    props: {
      guides: JSON.parse(JSON.stringify(guides)),
      roleOptions: JSON.parse(JSON.stringify(roleOptions)),
      roleCategories: JSON.parse(JSON.stringify(roleCategories)),
      companyOptions: JSON.parse(JSON.stringify(companyOptions)),
    },
    revalidate: 3600,
  };
}
